<ion-header animationHeader
  [animationContent]="content"
  [animationToolbar]="toolbar">

  <!-- Mapfre App Header -->
  <ion-toolbar *ngIf="ctx.isApp && mapfreAppHeader"
    color="base">
    <mapfre-app-header></mapfre-app-header>
  </ion-toolbar>

  <!-- Big Header -->
  <ion-toolbar #toolbar
    *ngIf="headerType === 'big'"
    class="header-secondary">
    <ion-buttons slot="start">
      <ion-menu-button *ngIf="ctx.isApp && menuButton && !mapfreAppHeader"
        mode="md"></ion-menu-button>
      <ion-button class="back-button"
        (click)="_onBack($event)"
        *ngIf="!menuButton && !disableBackButton">
        <ion-icon slot="icon-only"
          src="assets/images/families/back_arrow_icon.svg"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ title | translate }}</ion-title>
    <ion-icon *ngIf="headerIconSrc"
      [src]="headerIconSrc"
      slot="end"></ion-icon>
  </ion-toolbar>

  <!-- Normal Header -->
  <ng-container *ngIf="headerType === 'normal'">

    <ion-toolbar [ngClass]="{
      'header-app': ctx.isApp,
      'header-secondary header-secondary--sm header-secondary--reduced': !ctx.isApp
    }">
      <ion-buttons slot="start">
        <ion-button class="back-button"
          (click)="_onBack($event)"
          *ngIf="!disableBackButton">
          <ion-icon slot="icon-only"
            src="assets/images/families/back_arrow_icon.svg"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>{{ title | translate }}</ion-title>
      <ion-buttons slot="end">
        <ion-button *ngIf="!disableCancelButton"
          class="cancel-button"
          (click)="_onCancel($event)">
          <div class="cancel-button__text">{{ 'CANCEL' | translate }}</div>
          <ion-icon class="cancel-button__cross"
            name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <ion-toolbar *ngIf="progress" class="header-secondary header-secondary--sm header-secondary--reduced header-secondary--progress">
      <ion-buttons>
        <ion-progress-bar custom-palette
          color="medium-semi-light"
          [value]="progress"></ion-progress-bar>
        <ion-label>{{ progress * 100 }}% {{ 'COMPLETED' | translate }}</ion-label>
      </ion-buttons>
    </ion-toolbar>

    <mat-divider *ngIf="!ctx.isApp"></mat-divider>

  </ng-container>

</ion-header>

<ion-content class="bg-content"
  #content
  [scrollEvents]="headerType === 'big'">

  <div class="scroll-area">
    <div responsive-breakpoints
      reduced-responsive
      class="scroll-area__content">
      <div white-box-content>
        <ng-content></ng-content>
      </div>

      <div class="white-box-footer-buttons mapfre-hide-mobile">
        <ng-container [ngTemplateOutlet]="whiteBoxOuter"></ng-container>
      </div>

    </div>

    <div class="scroll-area__footer">

      <div class="scroll-area__footer-buttons">
        <ng-container [ngTemplateOutlet]="whiteBoxOuter"></ng-container>
      </div>

      <mapfre-footer *ngIf="!ctx.isApp"></mapfre-footer>
    </div>
  </div>
</ion-content>